<div class="ep-landing relative bg-green-500/0">
    <!-- Prismatic top stripe -->
    <div class="ep-stripe">
        <div class="ep-stripe__band" [style.background]="Y"></div>
        <div class="ep-stripe__band" [style.background]="R"></div>
        <div class="ep-stripe__band" [style.background]="B"></div>
        <div class="ep-stripe__band" [style.background]="O"></div>
    </div>

    <!-- Nav -->
    <nav class="ep-nav">
        <div class="ep-nav__brand">
            <img
                [src]="navLogoIconUrl"
                alt="EnvHeaven"
                class="ep-nav__logo"
                (error)="onLogoError($event)"
            />
            EnvHeaven
        </div>

        <!-- <div class="ep-nav__links hidden">
            <a href="#" class="ep-nav__link">Features</a>
            <a href="#" class="ep-nav__link">Docs</a>
            <a href="#" class="ep-nav__link">Pricing</a>
        </div> -->

        <!-- <button class="ep-nav__signin hidden">Sign In</button> -->
    </nav>

    <div class="
        absolute
        pointer-events-none inset-0 overflow-x-clip overflow-y-clip

        h-full w-lvw

        bg-cyan-400/0
        ">
        <img
            class="
                absolute right-0
                bg-pink-500/0

                top-[35lvh] translate-x-[80lvh]
                min-w-[120lvh] min-h-[120lvh]
                h-[120lvh] w-[120lvh]

                sm:top-[35lvh] sm:translate-x-[80lvh]
                sm:min-w-[140lvh] sm:min-h-[140lvh]
                sm:h-[140lvh] sm:w-[140lvh]

                md:top-[35lvh] md:translate-x-[100lvh]
                md:min-w-[160lvh] md:min-h-[160lvh]
                md:h-[160lvh] md:w-[160lvh]

                lg:top-[35lvh] lg:translate-x-[80lvh]
                lg:min-w-[160lvh] lg:min-h-[160lvh]
                lg:h-[160lvh] lg:w-[160lvh]

                xl:top-[35lvh] xl:translate-x-[50lvh]
                xl:min-w-[xl] xl:min-h-[160lvh]
                xl:h-[160lvh] xl:w-[160lvh]

                opacity-20
                "
                [src]="backgroundLogoUrl" alt="">
                <!-- src="http://127.0.0.1:51090/public/_app/features/generic/logo/013-envheaven-logo-02.png" alt=""> -->
                <!-- src="http://localhost:51080/assets/envheaven-logo.png" alt=""> -->
    </div>

    <!-- Hero -->
    <main class="ep-hero bg-pink-500/0 relative overflow-x-auto">

        <!-- <div
            class="ep-badge"
            [ngStyle]="{
                'border-color': Y + '40',
                color: Y,
                background: Y + '10',
            }"
        >
            &#9670; PRIVATE BETA
        </div> -->

        <div class="ep-hero__content bg-pink-500/0 relative">

            <h1 class="
                ep-headline
                pt-24

                text-[3rem] sm:text-[4rem] md:text-[6rem] lg:text-[7.5rem]
                bg-green-500/0
                ">
                Every
                <span [style.color]="Y">environment,</span>
                <br />
                always in
                <span class="ep-headline__gradient">sync.</span>
            </h1>

            <div class="
                hidden
                flex
                items-center justify-center min-h-screen
                bg-pink-500/50

                font-mono
                ">
                <div class="
                    bg-green-500/50

                    text-4xl
                    text-white
                    ">

                    <span class="
                        bg-red-500/50
                        inline-block
                        ">
                        I am a
                    </span>

                    <!-- The animated word list container -->
                    <span id="typewriter" class="
                        bg-blue-500/50
                        inline-block
                        overflow-hidden border-r-4
                        border-white
                        whitespace-nowrap
                        animate-typing
                        ">
                        Developer
                    </span>

                    <p>Caret <span class="typed-[color;width;space] typed-caret typed-caret-color-emerald-400 typed-caret-width-4 typed-caret-space-2 dark:typed-caret-color-emerald-600"></span>_END_END_END</p>
                </div>
            </div>

            <div class="ep-hero__copy">
                <!-- <p class="ep-subtext">
                    The developer environment management tool for engineering
                    teams that value velocity. Stop fighting configurations and
                    start shipping.
                </p> -->
                <p class="ep-subtext bg-pink-500/0 min-h-52">
                    The
                    <span class="
                        text-white
                        font-bold
                        bg-blue-400/20
                        px-1

                        typed-[front-end_developer;back-end_developer;devops;student;solo_dev;artists;Q.A.;vibe_coder;CI;CD;full-stack_developer;cloud_engineer;infrastructure_enthusiast;environment_tinkerer;code_alchemist;bug_squasher;feature_shipper;collaboration_champion;workflow_optimizer;velocity_seeker]
                        typed-caret
                        ">
                    </span>
                    environment management tool for engineering teams that value
                    velocity. Stop fighting infrastructure configurations and
                    start shipping.
                </p>

                @if (hasToShowWaitList) {
                <form class="ep-form" (ngSubmit)="onEmailSubmit()">
                    <input
                        class="ep-form__input"
                        type="email"
                        placeholder="your@email.com"
                        [(ngModel)]="email"
                        name="email"
                        autocomplete="email"
                        [disabled]="status !== 'idle'"
                        required
                    />
                    <button
                        class="ep-form__submit"
                        type="submit"
                        [disabled]="status !== 'idle'"
                        [ngStyle]="{
                            background:
                                status === 'success'
                                    ? '#22c55e'
                                    : status === 'error'
                                      ? '#E63946'
                                      : Y,
                            color: '#08090a',
                        }"
                    >
                        @if (status === "idle") {
                            <span>Join Waitlist</span>
                        }
                        @if (status === "submitting") {
                            <span class="ep-spinner"></span>
                        }
                        @if (status === "success") {
                            <span class="ep-form__success"
                                >&#10003; You're in!</span
                            >
                        }
                        @if (status === "error") {
                            <span class="ep-form__success">&#10007; Error</span>
                        }
                    </button>
                </form>
                }
                @else {
                <div class="
                    pointer-events-none

                    fixed z-10
                    left-0 bottom-0

                    -translate-x-[5rem] -translate-y-[3.5rem]
                    rotate-[30deg]

                    w-96

                    bg-orange-500

                    italic
                    text-lg text-center
                    align-middle

                    opacity-70
                    ">
                    <span>
                        Beta testing waitlist soon...
                    </span>
                </div>
                }

                @if (statusMessage) {
                    <p class="ep-form-message">{{ statusMessage }}</p>
                }
            </div>
        </div>

        <!-- Beta CTA -->
        @if (showBetaCta) {
            <div class="ep-beta-cta">
                <div class="ep-beta-divider"></div>
                <p class="ep-beta-label">The beta is live.</p>
                <a
                    href="https://beta.envheaven.com"
                    class="ep-btn-outline"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Try the beta now!
                </a>
            </div>
        }

        <!-- Features timeline -->
        <div class="ep-features">
            @for (f of features; track f) {
                <div class="ep-feature group">
                    <div
                        class="ep-feature__bar"
                        [style.background]="f.color"
                    ></div>
                    <div
                        class="ep-feature__number"
                        [ngStyle]="{ color: f.color + '40' }"
                    >
                        {{ f.n }}
                    </div>
                    <h2 class="ep-feature__title">{{ f.title }}</h2>
                    <p class="ep-feature__body">{{ f.body }}</p>
                    @if (f.showCode) {
                        <div class="ep-terminal">
                            <div
                                class="ep-terminal__bar"
                                [style.background]="f.color"
                            ></div>
                            <div class="ep-terminal__header">
                                <svg
                                    class="ep-terminal__icon"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                >
                                    <polyline
                                        points="4 17 10 11 4 5"
                                    ></polyline>
                                    <line
                                        x1="12"
                                        y1="19"
                                        x2="20"
                                        y2="19"
                                    ></line>
                                </svg>
                                <span>~/projects/api</span>
                            </div>
                            <div class="ep-terminal__body">

                                <p class="flex items-start gap-2 text-white font-bold">
                                    <span class="bg-green-700/0 w-4 shrink-0 text-right" [style.color]="f.color">$</span>
                                    <span>
                                        envheaven run local
                                    </span>
                                </p>

                                <p class="ep-terminal__muted flex items-start gap-2">
                                    <span class="bg-green-700/0 w-4 shrink-0 text-right">&rarr;</span>
                                    <span>
                                        Resolving "local-01" env-map...
                                    </span>
                                </p>

                                <p class="ep-terminal__muted flex items-start gap-2">
                                    <span class="bg-green-700/0 w-4 shrink-0 text-right">&rarr;</span>
                                    <span>
                                        All dependencies installed and updated (skipping).
                                    </span>
                                </p>

                                <p class="ep-terminal__muted flex items-start gap-2">
                                    <span class="bg-green-700/0 w-4 shrink-0 text-right">&rarr;</span>
                                    <span>
                                        Starting 4 servers
                                        ("website-01-angular-fe-01",
                                        "website-01-api-01",
                                        "website-01-cdn-01",
                                        "website-01-supabase-01")...
                                    </span>
                                </p>

                                <p class="ep-terminal__muted flex items-start gap-2">
                                    <span class="inline-block bg-green-700/0 w-4 text-right">&rarr;</span>
                                    <span>
                                        <span class="text-green-500">&#x2714;</span>
                                        (1/4)
                                        "website-01-angular-fe-01" started!
                                        <br>
                                        <br>
                                        running at:
                                        <br>
                                        <br>
                                        <span class="underline">http://localhost:51080/</span>
                                        (with this machine)
                                        <br>
                                        <span class="underline">http://127.0.0.1:51080/</span>
                                        (with this machine)
                                        <br>
                                        <span class="underline">http://192.168.0.42:51080/</span>
                                        (over your network)
                                        <br>
                                        <br>
                                        live console terminal at:
                                        <br>
                                        <br>
                                        <span class="underline">http://localhost:51082/console/1fb53c</span>
                                        (with this machine)
                                        <br>
                                        <span class="underline">http://127.0.0.1:51082/console/1fb53c</span>
                                        (with this machine)
                                        <br>
                                        <span class="underline">http://192.168.0.42:42991/console/1fb53c</span>
                                        (over your network)
                                        <br>
                                    </span>
                                </p>

                                <p class="ep-terminal__muted flex items-start gap-2">
                                    <span class="inline-block bg-green-700/0 w-4 text-right">&rarr;</span>
                                    <span>
                                        <span class="text-green-500">&#x2714;</span>
                                        (2/4)
                                        "website-01-cdn-01" started!
                                        <br>
                                        <br>
                                        running at:
                                        <br>
                                        <br>
                                        <span class="underline">http://localhost:51083/</span>
                                        (with this machine)
                                        <br>
                                        <span class="underline">http://127.0.0.1:51083/</span>
                                        (with this machine)
                                        <br>
                                        <span class="underline">http://192.168.0.42:51083/</span>
                                        (over your network)
                                        <br>
                                        <br>
                                        live console terminal at:
                                        <br>
                                        <br>
                                        <span class="underline">http://localhost:51082/console/68d516</span>
                                        (with this machine)
                                        <br>
                                        <span class="underline">http://127.0.0.1:51082/console/68d516</span>
                                        (with this machine)
                                        <br>
                                        <span class="underline">http://192.168.0.42:42991/console/68d516</span>
                                        (over your network)
                                        <br>
                                    </span>
                                </p>

                                <p class="ep-terminal__muted flex items-start gap-2">
                                    <span class="inline-block bg-green-700/0 w-4 text-right">&rarr;</span>
                                    <span>
                                        <span class="text-green-500">&#x2714;</span>
                                        (3/4)
                                        "website-01-supabase-01" started!
                                        <br>
                                        <br>
                                        running at:
                                        <br>
                                        <br>
                                        <span class="underline">http://localhost:51082/</span>
                                        (with this machine)
                                        <br>
                                        <span class="underline">http://127.0.0.1:51082/</span>
                                        (with this machine)
                                        <br>
                                        <span class="underline">http://192.168.0.42:51082/</span>
                                        (over your network)
                                        <br>
                                        <br>
                                        live console terminal at:
                                        <br>
                                        <br>
                                        <span class="underline">http://localhost:51082/console/efa046</span>
                                        (with this machine)
                                        <br>
                                        <span class="underline">http://127.0.0.1:51082/console/efa046</span>
                                        (with this machine)
                                        <br>
                                        <span class="underline">http://192.168.0.42:42991/console/efa046</span>
                                        (over your network)
                                        <br>
                                    </span>
                                </p>

                                <p class="ep-terminal__muted flex items-start gap-2">
                                    <span class="inline-block bg-green-700/0 w-4 text-right">&rarr;</span>
                                    <span>
                                        <span class="text-green-500">&#x2714;</span>
                                        (4/4)
                                        "website-01-api-01" started!
                                        <br>
                                        <br>
                                        running at:
                                        <br>
                                        <br>
                                        <span class="underline">http://localhost:51081/</span>
                                        (with this machine)
                                        <br>
                                        <span class="underline">http://127.0.0.1:51081/</span>
                                        (with this machine)
                                        <br>
                                        <span class="underline">http://192.168.0.42:51081/</span>
                                        (over your network)
                                        <br>
                                        <br>
                                        live console terminal at:
                                        <br>
                                        <br>
                                        <span class="underline">http://localhost:51082/console/10ea65</span>
                                        (with this machine)
                                        <br>
                                        <span class="underline">http://127.0.0.1:51082/console/10ea65</span>
                                        (with this machine)
                                        <br>
                                        <span class="underline">http://192.168.0.42:42991/console/10ea65</span>
                                        (over your network)
                                        <br>
                                    </span>
                                </p>

                                <p class="ep-terminal__muted">
                                    <span class="inline-block bg-green-700/0 w-4 text-right">&rarr;</span>
                                    <span class="text-green-500 font-bold">
                                        &#x2705; Environment "local-01" running!
                                    </span>
                                </p>

                                <p class="flex items-start gap-2 text-white font-bold">
                                    <span class="bg-green-700/0 w-4 shrink-0 text-right" [style.color]="f.color">$</span>
                                    <span class="
                                        typed-caret
                                        typed-[envheaven_run_local-01;eh_run_fake_local;eh_run_local-01;envheaven;eh;envheaven_run_development-04;envheaven_deploy_development;envheaven_deploy_production;eh_deploy_beta;envheaven_deploy_beta;eh_run_local-01;envheaven_run_development-02]">

                                    </span>
                                </p>

                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    </main>

    <div class="
        h-80 w-full
        bg-blue-500/0">

    </div>

    <!-- Footer -->
    <!-- bg-[#08090a] -->
    <!-- bg-pink-500 -->
    <div class="
        ep-footer-wrap
        absolute
        z-20  bottom-0

        bg-[#08090a]

        w-full
        ">

        <div class="ep-stripe ep-stripe--footer">
            <div class="ep-stripe__band" [style.background]="O"></div>
            <div class="ep-stripe__band" [style.background]="B"></div>
            <div class="ep-stripe__band" [style.background]="R"></div>
            <div class="ep-stripe__band" [style.background]="Y"></div>
        </div>
        <footer class="ep-footer">
            <div class="ep-footer__brand">
                <img
                    [src]="navLogoIconUrl"
                    alt="EnvHeaven"
                    class="ep-footer__logo"
                    (error)="onLogoError($event)"
                />
                EnvHeaven &copy; {{ currentYear }}
            </div>
            <div class="ep-footer__links">
                <!-- <a href="#" class="ep-footer__link">Twitter</a> -->
                <a href="https://github.com/EnvHeaven/EnvHeaven" target="_blank" class="ep-footer__link underline">
                    <span class="">GitHub</span>
                    <span class="font-extrabold">
                        &#x1F855;
                    </span>
                </a>
                <!-- <a href="#" class="ep-footer__link">Discord</a> -->
            </div>
        </footer>
    </div>
</div>
<app-version-panel></app-version-panel>
